import {
  IApiCompanyRow,
  ISourcingCompanyRow,
  sourcingCompanyRowSchema,
} from '../../schemas/SourcingListItems.schema';
import { IAgentSearchResponse, agentSourcingCompanyRowSchema } from '../../schemas/AgentSearchResults.schema';
import { MaggieHttp } from '../MaggieHttp';
import { SOURCING_SEARCH_MOCK_DATA } from '../../pages/Sourcing/data/sourcingSearchMockData';

// TODO: remove mock fallback once the search API is deployed
export async function getSourcingSearchById(searchId: string): Promise<ISourcingCompanyRow[]> {
  try {
    const { data } = await MaggieHttp.sourcing.get<IApiCompanyRow[]>(`/api/v1/results/${searchId}/all`);
    return data.map((c) => sourcingCompanyRowSchema.cast(c));
  } catch {
    return [...SOURCING_SEARCH_MOCK_DATA];
  }
}

export async function getAgentSearchResultsById(searchId: string): Promise<ISourcingCompanyRow[]> {
  const firstPage = await MaggieHttp.sourcing.get<IAgentSearchResponse>(`/ai-agents/v1/results/${searchId}`);
  const allItems = [...firstPage.data.data];

  for (let page = firstPage.data.page + 1; page <= firstPage.data.total_pages; page += 1) {
    const { data } = await MaggieHttp.sourcing.get<IAgentSearchResponse>(
      `/ai-agents/v1/results/${searchId}`,
      { params: { page } }
    );
    allItems.push(...data.data);
  }

  return allItems.map((item) => agentSourcingCompanyRowSchema.cast(item));
}
